
const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      title: 'Identify the Crux',
      description: 'We audit operations to pinpoint where revenue stalls, experience degrades, or efficiency collapses.',
      icon: 'ri-search-eye-line',
      image: 'https://public.readdy.ai/ai/img_res/93d9ecec8faff92050bed7f079909a79.jpg'
    },
    {
      number: '02',
      title: 'Engineer the System',
      description: 'AI workflows are architected to integrate with your existing stack and team — not disrupt it.',
      icon: 'ri-tools-line',
      image: 'https://readdy.ai/api/search-image?query=Multiple%20X%20cross%20patterns%20interconnected%20forming%20a%20system%20architecture%20blueprint%20emerald%20green%20and%20teal%20glowing%20connection%20nodes%20on%20dark%20background%20representing%20engineering%20and%20integration&width=500&height=350&seq=procx2&orientation=landscape'
    },
    {
      number: '03',
      title: 'Deploy & Optimize',
      description: 'Systems launch quickly, then evolve through performance tracking and refinement.',
      icon: 'ri-rocket-2-line',
      image: 'https://readdy.ai/api/search-image?query=X%20cross%20shape%20transforming%20into%20upward%20arrow%20with%20performance%20metrics%20emerald%20green%20glowing%20geometric%20lines%20on%20dark%20background%20representing%20deployment%20and%20optimization&width=500&height=350&seq=procx3&orientation=landscape'
    },
  ];

  return (
    <section className="bg-zinc-950 py-32 relative overflow-hidden">
      {/* X Pattern Background */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="xPatternProcess" x="0" y="0" width="50" height="50" patternUnits="userSpaceOnUse">
              <line x1="0" y1="0" x2="50" y2="50" stroke="#10B981" strokeWidth="0.5" />
              <line x1="50" y1="0" x2="0" y2="50" stroke="#10B981" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#xPatternProcess)" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="text-center mb-20">
          <span className="text-emerald-400 text-xs font-semibold uppercase tracking-widest mb-4 block">
            OUR PROCESS
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-white">
            The CruxOnAI Deployment Model
          </h2>
        </div>

        <div className="space-y-16">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}
            >
              <div className={`${index % 2 === 1 ? 'lg:order-2' : 'lg:order-1'}`}>
                <div className="relative">
                  <span className="absolute -top-8 -left-4 text-9xl font-black text-emerald-500/10">
                    {step.number}
                  </span>
                  <div className="relative z-10">
                    <div className="w-14 h-14 flex items-center justify-center bg-emerald-500/10 rounded-xl mb-6">
                      <i className={`${step.icon} text-emerald-400 text-2xl`}></i>
                    </div>
                    <h3 className="text-3xl font-bold text-white mb-4">
                      {step.title}
                    </h3>
                    <p className="text-gray-300 text-lg leading-relaxed max-w-lg">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
              
              <div className={`${index % 2 === 1 ? 'lg:order-1' : 'lg:order-2'}`}>
                <div className="relative rounded-2xl overflow-hidden border border-zinc-800 group">
                  <img
                    src={step.image}
                    alt={step.title}
                    className="w-full h-72 object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-zinc-950/80 to-transparent"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
